import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/_models';
import { Nip } from 'src/app/_models/nip';
import { Operation } from 'src/app/_models/operation';
import { PackageType } from 'src/app/_models/package_type';
import { Partner } from 'src/app/_models/partner';
import { Product } from 'src/app/_models/product';
import { ProductType } from 'src/app/_models/product_type';
import { Status } from 'src/app/_models/status';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessService } from 'src/app/_services/mess-service.service';
import { NipService } from 'src/app/_services/nip.service';
import { DatePipe } from '@angular/common';
import { Activites } from 'src/app/_models/activites';
import { filter } from 'rxjs/operators';
import { ActiveTimeTracker } from 'src/app/_models/active-time-tracker';

@Component({
  selector: 'app-nip-edit',
  templateUrl: './nip-edit.component.html',
  styleUrls: ['./nip-edit.component.scss'],
  providers: [DatePipe],
})
export class NipEditComponent implements OnInit, OnDestroy {
  updateNipForm: FormGroup;
  editTimeTrackerForm: FormGroup;
  timeTrackerId: number;

  disableSave: boolean = true;
  loading = false;
  showModal = false;

  allPackageTypes: PackageType[];

  allProductTypes: ProductType[];

  allPartners: Partner[];

  allProducts: Product[];
  selectedProduct: Product;
  selectedProductOperations: Operation[];

  allStatuses: Status[];

  allTimeTrackers: ActiveTimeTracker[];

  currentUser: User;
  currentDate = formatDate(new Date(), 'dd.MM.yyyy', 'en');

  isFromAddPage: boolean = false;

  savedFormData: Nip;

  nipForEdit: Nip;

  allActivities: Activites;

  allPriority = [
    { name: 'Hitno', label: 0 },
    { name: 'Regularno', label: 2 },
    { name: 'Lager', label: 1 },
  ];

  getEditNipData: Nip;

  // Users that can edit main NIP fields
  authUsersForEdit = ['admin', 'prodavac'];
  isUserAuthForEdit: boolean;

  // Checkbox group
  readyItemsGroup: any[] = [
    { name: 'Radni nalog odštampan', value: 'printed' },
    { name: 'Dokumentacija spremna', value: 'documentation_ready' },
    { name: 'Materijal istrebovan', value: 'material_ready' },
    // { name: 'Zatvori nalog', value: 'complete' },
  ];
  selectedItemsGroup: any[];

  subscriptions: Subscription[] = [];

  reportData: any[];

  constructor(
    private fb: FormBuilder,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private nipService: NipService,
    private datePipe: DatePipe
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    // this.selectedItemsGroup = this.readyItemsGroup.slice(1,2);
    // * Get current user data
    this.currentUser = this.authService.userValue;

    // * Check is user authorized to edit main fields
    this.isUserAuthForEdit = this.authService.isAuthorized(
      this.authUsersForEdit
    );

    this.editTimeTrackerForm = this.fb.group({
      start: [''],
      end: [''],
      produced_amount: '',
    });

    // * Create form
    this.updateNipForm = this.fb.group({
      batch: ['', Validators.required],
      creator_id: [this.currentUser.user.id, Validators.required],
      request_nr: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      partner_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      deadline: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      packaging_type_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      required_units: [{ value: '', disabled: this.isUserAuthForEdit }],
      planned_units: [{ value: '', disabled: this.isUserAuthForEdit }],
      status_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      note: [{ value: '', disabled: this.isUserAuthForEdit }],
      complaint: [''],

      total_estimated_time: [{ value: '', disabled: true }],
      product_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      priority: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
            'prodavac',
          ]),
        },
      ],
      parallel_operations: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
      ready_items: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
      complete: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
      enable_add_operations: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
    });

    // * Get data for update
    this.subscriptions.push(
      this.nipService.updateNipData.subscribe((nip: any) => {
        if (!nip) {
          return;
        }

        this.nipForEdit = nip;

        this.nipForEdit.time_trackers = this.nipForEdit.time_trackers.concat(
          nip.active_time_trackers
        );

        // Selected checkbox
        this.selectedItemsGroup = nip.ready_items;
        this.onGetallActivities(1);
        this.createFormForUpdate();

        this.getReport();
      })
    );

    if (!this.nipForEdit) {
      this.router.navigate(['/nip'], { relativeTo: this.route });
    }

    // * Get all data for form fields
    this.subscriptions.push(
      this.nipService.getCreateData().subscribe((getEditNipData) => {
        this.getEditNipData = getEditNipData;

        // Products
        this.allProducts = getEditNipData.products;

        //* Show only products that have not been deleted or have ID same with Product from NipForEdit
        this.allProducts = this.allProducts.filter(
          (product) =>
            product.id == this.nipForEdit.product_id ||
            product.deleted_at == null
        );

        this.allProducts.forEach((product) => {
          // Patch operations for product in case that operations for some products are deleted
          if (product.id == this.nipForEdit.product_id) {
            product.operations = this.nipForEdit.product.operations;
          }
        });

        this.selectedProduct = this.allProducts.find(
          (product) => product.id === this.nipForEdit.product_id
        );
        this.selectedProductOperations = this.selectedProduct.operations;
        this.checkIsUserFromAddPage();
        // Package types
        this.allPackageTypes = getEditNipData.packaging_types;

        // Partners
        this.allPartners = getEditNipData.partners;

        // Statuses
        this.allStatuses = getEditNipData.statuses;

        // * Get previous url
        this.subscriptions.push(
          this.route.queryParams.subscribe((params) => {
            // Defaults to 0 if no query param provided.
            const previousUrl = params['fromPage'] || 0;
            const addedPartner = params['addedPartner'] || 0;
            this.isFromAddPage = previousUrl != 0 ? true : false;
            if (addedPartner !== 0) {
              // Proverava da li je korisnik koji dolazi sa ADD stranice dodao Partnera,
              // ako jeste ubacuje ID tog partnera u formu
              this.updateNipForm.patchValue({
                partner_id: this.allPartners.find(
                  (partner) => partner.company == addedPartner
                ).id,
              });
            }
          })
        );
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Update nip === //
  onUpdateNip() {
    const nip = this.updateNipForm.getRawValue();

    let datePipe = new DatePipe('en-US');
    nip.deadline = datePipe.transform(nip.deadline, 'yyyy-MM-dd');
    nip.ready_items = this.selectedItemsGroup;
    this.subscriptions.push(
      this.nipService.updateNip(this.nipForEdit.id, nip).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešna izmena',
            detail: 'Uspešno ste izmenili NIP.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.updateNipForm;
          const messService = this.messService;

          // && !errorObj.ready_items

          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl && !errorObj.ready_items) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * Export to PDF === //
  onExportToPDF() {
    this.subscriptions.push(
      this.nipService.exportToPDF(this.nipForEdit.id).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
      })
    );
  }

  onExportControlSheetToPDF() {
    this.subscriptions.push(
      this.nipService
        .exportControlSheetToPDF(this.nipForEdit.id)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
        })
    );
  }

  onExportZK() {
    this.subscriptions.push(
      this.nipService.exportZK(this.nipForEdit.id).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
      })
    );
  }

  // * Helpers === //
  private onGetallActivities(pageIndex: number) {
    this.subscriptions.push(
      this.nipService
        .getActivites(this.nipForEdit.id, pageIndex)
        .subscribe((responseData: Activites) => {
          this.allActivities = responseData;
        })
    );
  }

  findSelectedPartner() {
    return this.allPartners.find(
      (partner) => partner.id == this.updateNipForm.get('partner_id').value
    );
  }

  findSelectedProduct() {
    return this.allProducts.find(
      (product) => product.id == this.updateNipForm.get('product_id').value
    );
  }

  // Remove or add item when user check/uncheck checkbox
  onCheckItem(itemValue) {
    if (this.selectedItemsGroup.includes(itemValue)) {
      this.selectedItemsGroup = this.selectedItemsGroup.filter(
        (item) => item !== itemValue
      );
    } else {
      this.selectedItemsGroup.push(itemValue);
    }
  }

  // * Activites on page change
  onActivitesPageChange(event) {
    this.onGetallActivities(event.page + 1);
  }

  getControls() {
    return (<FormGroup>this.updateNipForm).controls;
  }

  newProductSelected(event) {
    let selectedProductId = event.value;
    this.selectedProduct = this.allProducts.find(
      (product) => product.id === selectedProductId
    ); // Find product with selected ID
    this.selectedProductOperations = this.selectedProduct.operations;
    this.updateNipForm.patchValue({
      total_estimated_time: this.selectedProduct.total_estimated_time,
    });
  }

  // * Check if user come from some ADD page (NIP etc.)
  private checkIsUserFromAddPage() {
    if (this.isFromAddPage) {
      this.subscriptions.push(
        this.nipService.saveFormData.subscribe((responseData: Nip) => {
          this.savedFormData = responseData;
        })
      );
      // Patch form with saved data
      if (this.savedFormData != null) {
        this.patchFormData();
      }
    }
  }

  getReport() {
    this.subscriptions.push(
      this.nipService.getReport(this.nipForEdit.id).subscribe({
        next: (res) => {
          this.reportData = res.data;
        },
      })
    );
  }

  private createFormForUpdate() {
    this.updateNipForm.patchValue({
      batch: this.nipForEdit.batch,
      product_id: this.nipForEdit.product_id,
      packaging_type_id: this.nipForEdit.packaging_type_id,
      status_id: this.nipForEdit.status_id,
      required_units: this.nipForEdit.required_units,
      planned_units: this.nipForEdit.planned_units,
      note: this.nipForEdit.note,
      complaint: this.nipForEdit.complaint,
      total_estimated_time: this.nipForEdit.product.total_estimated_time,
      request_nr: this.nipForEdit.request_nr,
      partner_id: this.nipForEdit.partner_id,
      deadline: new Date(this.nipForEdit.deadline),
      parallel_operations: this.nipForEdit.parallel_operations,
      priority: this.nipForEdit.priority,
      complete: this.nipForEdit?.complete,
      enable_add_operations: this.nipForEdit.enable_add_operations,
    });
  }

  private patchFormData() {
    this.updateNipForm.patchValue({
      batch: this.nipForEdit.batch,
      product_id: this.savedFormData.product_id,
      packaging_type_id: this.savedFormData.packaging_type_id,
      status_id: this.savedFormData.status_id,
      required_units: this.savedFormData.required_units,
      planned_units: this.savedFormData.planned_units,
      note: this.savedFormData.note,
      total_estimated_time: this.savedFormData.total_estimated_time,
      request_nr: this.savedFormData.request_nr,
      partner_id: this.savedFormData.partner_id,
      deadline: this.savedFormData.deadline,
    });
    // Update operation list
    this.selectedProduct = this.allProducts.find(
      (product) => product.id === this.savedFormData.product_id
    );
    this.selectedProductOperations = this.selectedProduct.operations;
  }

  // * Emit form when user click add partners, to save data
  goToAddPage() {
    const nip = this.updateNipForm.getRawValue();
    this.nipService.saveFormData.next(nip);
  }

  onEditTimeTracker(data) {
    this.timeTrackerId = data?.id;
    this.showModal = true;

    this.editTimeTrackerForm.patchValue({
      start: this.datePipe.transform(data?.start, 'dd.MM.yyyy HH:mm'),
      end: this.datePipe.transform(data?.end, 'dd.MM.yyyy HH:mm'),
      produced_amount: data?.produced_amount,
    });
  }

  onSaveTimeTrackerChanges() {
    const form = this.editTimeTrackerForm.getRawValue();

    this.subscriptions.push(
      this.nipService.updateTimeTracker(this.timeTrackerId, form).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešna izmena',
            detail: 'Uspešno ste izmenili.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const messService = this.messService;

          // && !errorObj.ready_items

          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl && !errorObj.ready_items) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  formatStartDate() {
    const form = this.editTimeTrackerForm.getRawValue();
    this.editTimeTrackerForm
      .get('start')
      .setValue(this.datePipe.transform(form?.start, 'dd.MM.yyyy HH:mm'));
  }

  formatEndDate() {
    const form = this.editTimeTrackerForm.getRawValue();
    this.editTimeTrackerForm
      .get('end')
      .setValue(this.datePipe.transform(form?.end, 'dd.MM.yyyy HH:mm'));
  }
}
